export const getInitials = (name: string): string  => {
    const splittedString = name.split(" ")
    let initials: string = ""
    splittedString.map((splittedPart) => initials = initials + splittedPart.at(0))
    return initials
}
